import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withModifiers as _withModifiers, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04baed10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-global" }
const _hoisted_2 = { class: "archive-header flex items-center justify-between mb-4" }
const _hoisted_3 = { class: "page-title" }
const _hoisted_4 = { class: "archive-breadcrumbs flex items-center gap-2 mb-6 text-sm" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400" }, "/", -1))
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "archive-actions flex justify-between mb-6" }
const _hoisted_8 = { class: "archive-actions__group flex" }
const _hoisted_9 = { class: "archive-actions__group flex" }
const _hoisted_10 = {
  key: 0,
  class: "text-center py-8 text-gray-500"
}
const _hoisted_11 = ["aria-label"]
const _hoisted_12 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_13 = { class: "bg-table-header" }
const _hoisted_14 = { class: "px-4 py-3 w-10" }
const _hoisted_15 = ["checked"]
const _hoisted_16 = { class: "px-4 py-3 text-left text-sm font-semibold text-gray-600" }
const _hoisted_17 = { class: "px-4 py-3 text-left text-sm font-semibold text-gray-600" }
const _hoisted_18 = { class: "px-4 py-3 text-left text-sm font-semibold text-gray-600" }
const _hoisted_19 = { class: "px-4 py-3 text-left text-sm font-semibold text-gray-600" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-3 w-10" }, null, -1))
const _hoisted_21 = { class: "divide-y divide-gray-100 bg-white" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["checked", "onChange"]
const _hoisted_24 = { class: "px-4 py-3 text-sm" }
const _hoisted_25 = { class: "flex items-center" }
const _hoisted_26 = { class: "px-4 py-3 text-sm" }
const _hoisted_27 = { class: "px-4 py-3 text-sm" }
const _hoisted_28 = { class: "px-4 py-3 text-sm" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = {
  colspan: "6",
  class: "px-4 py-8 text-center text-gray-500"
}
const _hoisted_31 = {
  key: 2,
  class: "flex flex-row-reverse mt-4"
}

import { ref, computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import { t } from "@/i18n";
import {
  DocumentAddIcon,
  FolderAddIcon,
  RefreshIcon,
  TrashIcon,
  LockClosedIcon,
  FolderIcon,
  DocumentTextIcon,
  DownloadIcon,
} from "@heroicons/vue/outline";
import { Button, ActionMenu } from "@/components/common";
import TablePagination from "@/components/common/pagination/TablePagination.vue";
import FolderCreateModal from "@/components/documents/FolderCreateModal.vue";
import FolderMoveModal from "@/components/documents/FolderMoveModal.vue";
import FolderAccessModal from "@/components/documents/FolderAccessModal.vue";
import { DocumentFolderDataService, DocumentDataService } from "@/services";
import {
  DocumentFolder,
  FolderDocument,
} from "@/types/documents/folder/DocumentFolder";
import { useToast } from "vue-toastification";

type TableItem = {
  id: string;
  type: "folder" | "document";
  title: string;
  regNumber?: string;
  date?: string;
};


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const toast = useToast();

const ITEMS_LIMIT = 20;

const currentFolderId = ref<string | null>(null);
const breadcrumbs = ref<{ id: string; title: string }[]>([]);
const folders = ref<DocumentFolder[]>([]);
const documents = ref<FolderDocument[]>([]);
const countItems = ref(0);
const currentPage = ref(1);
const loading = ref(false);
const downloadLoading = ref(false);

const selectedFolderIds = ref<string[]>([]);
const selectedDocumentIds = ref<string[]>([]);

const createFolderModalShow = ref(false);
const moveModalShow = ref(false);
const accessModalShow = ref(false);
const accessFolderId = ref(0);

const totalPages = computed(() =>
  Math.max(1, Math.ceil(countItems.value / ITEMS_LIMIT))
);
const startPage = computed(() => Math.max(1, currentPage.value - 2));
const endPage = computed(() =>
  Math.min(totalPages.value, currentPage.value + 2)
);

const tableItems = computed<TableItem[]>(() => {
  const folderItems: TableItem[] = folders.value.map((f) => ({
    id: f.id,
    type: "folder" as const,
    title: f.title,
    date: f.updatedAt || f.createdAt,
  }));
  const documentItems: TableItem[] = documents.value.map((d) => ({
    id: d.id,
    type: "document" as const,
    title: d.title,
    regNumber: d.regNumber,
  }));
  return [...folderItems, ...documentItems];
});

const hasSelection = computed(
  () =>
    selectedFolderIds.value.length > 0 || selectedDocumentIds.value.length > 0
);

const isAllSelected = computed(() => {
  if (!tableItems.value.length) return false;
  return tableItems.value.every((item) => isSelected(item));
});

function isSelected(item: TableItem) {
  return item.type === "folder"
    ? selectedFolderIds.value.includes(item.id)
    : selectedDocumentIds.value.includes(item.id);
}

function toggleSelection(item: TableItem) {
  if (item.type === "folder") {
    const index = selectedFolderIds.value.indexOf(item.id);
    if (index >= 0) selectedFolderIds.value.splice(index, 1);
    else selectedFolderIds.value.push(item.id);
  } else {
    const index = selectedDocumentIds.value.indexOf(item.id);
    if (index >= 0) selectedDocumentIds.value.splice(index, 1);
    else selectedDocumentIds.value.push(item.id);
  }
}

function toggleAll() {
  if (isAllSelected.value) {
    selectedFolderIds.value = [];
    selectedDocumentIds.value = [];
  } else {
    selectedFolderIds.value = folders.value.map((f) => f.id);
    selectedDocumentIds.value = documents.value.map((d) => d.id);
  }
}

function rowActions(item: TableItem) {
  const actions = [
    {
      text: t("archive.open"),
      icon: FolderIcon,
      iconColor: "",
      action: () =>
        item.type === "folder" ? openFolder(item.id) : openDocument(item.id),
    },
  ];
  if (item.type === "folder") {
    actions.push(
      {
        text: t("archive.folderAccess"),
        icon: LockClosedIcon,
        iconColor: "",
        action: () => openAccessModal(item.id),
      },
      {
        text: t("common.delete"),
        icon: TrashIcon,
        iconColor: "text-red-500",
        action: () => {
          void deleteFolder(item.id);
        },
      }
    );
  }
  return actions;
}

function clearSelection() {
  selectedFolderIds.value = [];
  selectedDocumentIds.value = [];
}

async function loadItems(page = currentPage.value) {
  loading.value = true;
  try {
    const response = await DocumentFolderDataService.list(
      currentFolderId.value,
      page - 1,
      ITEMS_LIMIT
    );
    const data = response.data.data;
    folders.value = data.folders;
    documents.value = data.documents;
    countItems.value = data.countItems;
    currentPage.value = page;
  } catch (error: any) {
    toast.error(error.response?.data?.message || t("common.error"));
  } finally {
    loading.value = false;
  }
}

async function openFolder(folderId: string | null) {
  currentFolderId.value = folderId;
  clearSelection();

  if (folderId === null) {
    breadcrumbs.value = [];
  } else {
    try {
      const response = await DocumentFolderDataService.view(folderId);
      const folder = response.data.data;
      const existingIndex = breadcrumbs.value.findIndex(
        (b) => b.id === folderId
      );
      if (existingIndex >= 0) {
        breadcrumbs.value = breadcrumbs.value.slice(0, existingIndex + 1);
      } else {
        breadcrumbs.value.push({ id: folder.id, title: folder.title });
      }
    } catch (error: any) {
      toast.error(error.response?.data?.message || t("common.error"));
    }
  }

  currentPage.value = 1;
  await loadItems(1);
}

function handleRowDblClick(item: TableItem) {
  if (item.type === "folder") openFolder(item.id);
  else openDocument(item.id);
}

function openDocument(documentId: string) {
  router.push({ name: "DocumentDetails", params: { id: documentId } });
}

function openAccessModal(folderId: string) {
  accessFolderId.value = folderId;
  accessModalShow.value = true;
}

async function deleteFolder(folderId: string) {
  if (!confirm(t("archive.deleteFolderConfirm"))) return;
  try {
    const response = await DocumentFolderDataService.delete(folderId);
    toast.success(response.data.message);
    await loadItems();
  } catch (error: any) {
    toast.error(error.response?.data?.message || t("common.error"));
  }
}

async function deleteSelectedFolders() {
  if (!selectedFolderIds.value.length) return;
  if (!confirm(t("archive.deleteFolderConfirm"))) return;
  try {
    for (const folderId of selectedFolderIds.value) {
      await DocumentFolderDataService.delete(folderId);
    }
    toast.success(t("archive.deleteSuccess"));
    clearSelection();
    await loadItems();
  } catch (error: any) {
    toast.error(error.response?.data?.message || t("common.error"));
  }
}

function onMoveComplete() {
  clearSelection();
  loadItems();
}

async function downloadFolderPackage() {
  if (!currentFolderId.value) return;
  downloadLoading.value = true;
  try {
    const response = await DocumentFolderDataService.downloadPackage(
      currentFolderId.value
    );
    const archiveGuid = response.data.data.fileGuid;
    const blobResponse = await DocumentDataService.downloadDocument(
      archiveGuid,
      null
    );
    const url = window.URL.createObjectURL(blobResponse.data);
    const link = document.createElement("a");
    link.href = url;
    link.download = `folder-${currentFolderId.value}.zip`;
    link.click();
    window.URL.revokeObjectURL(url);
  } catch (error: any) {
    toast.error(error.response?.data?.message || t("common.error"));
  } finally {
    downloadLoading.value = false;
  }
}

onMounted(() => loadItems());

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(t)("archive.title")), 1),
      (currentFolderId.value)
        ? (_openBlock(), _createBlock(_unref(Button), {
            key: 0,
            class: "flex",
            onClick: downloadFolderPackage,
            disabled: downloadLoading.value
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(DownloadIcon), { class: "w-5 mr-1" }),
              _createTextVNode(" " + _toDisplayString(_unref(t)("archive.downloadFolder")), 1)
            ]),
            _: 1
          }, 8, ["disabled"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        type: "button",
        class: "text-green-600 hover:underline",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (openFolder(null)))
      }, _toDisplayString(_unref(t)("archive.root")), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(breadcrumbs.value, (crumb) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: crumb.id
        }, [
          _hoisted_5,
          _createElementVNode("button", {
            type: "button",
            class: "text-green-600 hover:underline",
            onClick: ($event: any) => (openFolder(crumb.id))
          }, _toDisplayString(crumb.title), 9, _hoisted_6)
        ], 64))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_router_link, { to: { name: 'DocumentCreate' } }, {
          default: _withCtx(() => [
            _createVNode(_unref(Button), { class: "mr-3 flex" }, {
              default: _withCtx(() => [
                _createVNode(_unref(DocumentAddIcon), { class: "w-5 mr-1" }),
                _createTextVNode(" " + _toDisplayString(_unref(t)("archive.createDocument")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(Button), {
          class: "flex",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (createFolderModalShow.value = true))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(FolderAddIcon), { class: "w-5 mr-1" }),
            _createTextVNode(" " + _toDisplayString(_unref(t)("archive.createFolder")), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_unref(Button), {
          class: "mr-3 flex",
          disabled: !_unref(hasSelection),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (moveModalShow.value = true))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(RefreshIcon), { class: "w-5 mr-1" }),
            _createTextVNode(" " + _toDisplayString(_unref(t)("archive.move")), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_unref(Button), {
          class: "flex",
          disabled: !selectedFolderIds.value.length,
          onClick: deleteSelectedFolders
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TrashIcon), { class: "w-5 mr-1" }),
            _createTextVNode(" " + _toDisplayString(_unref(t)("archive.delete")), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(t)("archive.loading")), 1))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "table-scroll",
          style: {"--table-min-width":"760px"},
          tabindex: "0",
          role: "region",
          "aria-label": _ctx.$t('common.scrollableTable'),
          "data-pagination-scroll-anchor": ""
        }, [
          _createElementVNode("table", _hoisted_12, [
            _createElementVNode("thead", _hoisted_13, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_14, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    checked: _unref(isAllSelected),
                    onChange: toggleAll,
                    class: "w-4 h-4"
                  }, null, 40, _hoisted_15)
                ]),
                _createElementVNode("th", _hoisted_16, _toDisplayString(_unref(t)("common.title")), 1),
                _createElementVNode("th", _hoisted_17, _toDisplayString(_unref(t)("archive.regNumber")), 1),
                _createElementVNode("th", _hoisted_18, _toDisplayString(_unref(t)("archive.type")), 1),
                _createElementVNode("th", _hoisted_19, _toDisplayString(_unref(t)("archive.date")), 1),
                _hoisted_20
              ])
            ]),
            _createElementVNode("tbody", _hoisted_21, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tableItems), (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: `${item.type}-${item.id}`,
                  class: "hover:bg-gray-50 cursor-pointer",
                  onClick: ($event: any) => (handleRowDblClick(item))
                }, [
                  _createElementVNode("td", {
                    class: "px-4 py-3",
                    onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      checked: isSelected(item),
                      onChange: ($event: any) => (toggleSelection(item)),
                      class: "w-4 h-4"
                    }, null, 40, _hoisted_23)
                  ]),
                  _createElementVNode("td", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      (item.type === 'folder')
                        ? (_openBlock(), _createBlock(_unref(FolderIcon), {
                            key: 0,
                            class: "w-5 h-5 mr-2 text-gray-500"
                          }))
                        : (_openBlock(), _createBlock(_unref(DocumentTextIcon), {
                            key: 1,
                            class: "w-5 h-5 mr-2 text-gray-500"
                          })),
                      _createTextVNode(" " + _toDisplayString(item.title), 1)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_26, _toDisplayString(item.regNumber || "—"), 1),
                  _createElementVNode("td", _hoisted_27, _toDisplayString(item.type === "folder"
                  ? _unref(t)("archive.folder")
                  : _unref(t)("archive.document")), 1),
                  _createElementVNode("td", _hoisted_28, _toDisplayString(item.date || "—"), 1),
                  _createElementVNode("td", {
                    class: "px-4 py-3 text-right relative",
                    onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    _createVNode(_unref(ActionMenu), {
                      actions: rowActions(item)
                    }, null, 8, ["actions"])
                  ])
                ], 8, _hoisted_22))
              }), 128)),
              (!_unref(tableItems).length)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_29, [
                    _createElementVNode("td", _hoisted_30, _toDisplayString(_unref(t)("common.noData")), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ], 8, _hoisted_11)),
    (_unref(totalPages) > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
          _createVNode(TablePagination, {
            current: currentPage.value,
            "onUpdate:current": _cache[5] || (_cache[5] = ($event: any) => ((currentPage).value = $event)),
            "total-pages": _unref(totalPages),
            "onUpdate:total-pages": _cache[6] || (_cache[6] = ($event: any) => (_isRef(totalPages) ? (totalPages).value = $event : null)),
            "start-page": _unref(startPage),
            "end-page": _unref(endPage),
            onPageChanged: loadItems
          }, null, 8, ["current", "total-pages", "start-page", "end-page"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(FolderCreateModal, {
      show: createFolderModalShow.value,
      "parent-folder-id": currentFolderId.value,
      onHide: _cache[7] || (_cache[7] = ($event: any) => (createFolderModalShow.value = false)),
      onSubmit: loadItems
    }, null, 8, ["show", "parent-folder-id"]),
    _createVNode(FolderMoveModal, {
      show: moveModalShow.value,
      "checked-document-ids": selectedDocumentIds.value,
      "checked-folder-ids": selectedFolderIds.value,
      onHide: _cache[8] || (_cache[8] = ($event: any) => (moveModalShow.value = false)),
      onSubmit: onMoveComplete
    }, null, 8, ["show", "checked-document-ids", "checked-folder-ids"]),
    _createVNode(FolderAccessModal, {
      show: accessModalShow.value,
      "folder-id": accessFolderId.value,
      onHide: _cache[9] || (_cache[9] = ($event: any) => (accessModalShow.value = false))
    }, null, 8, ["show", "folder-id"])
  ]))
}
}

})